export interface IPersonComment {
  commentId: number;
  personId: number;
  author: string;
  comments: string;
  createdOn: string;
  updatedOn: string;
  commentDetails: string;
}

export class PersonComment implements IPersonComment {
  commentId;
  personId;
  author;
  comments;
  createdOn;
  updatedOn;
  commentDetails;

  constructor(config: IPersonComment) {
    this.commentId = config.commentId;
    this.personId = config.personId;
    this.author = config.author;
    this.comments = config.comments;
    this.createdOn = config.createdOn;
    this.updatedOn = config.updatedOn;
    this.commentDetails = config.commentDetails;
  }
}
